import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    text: {
      flexGrow: 0,
    },
    icon: {
      color: theme.palette.green.dark,
    },
    tooltip: {
      height: theme.spacing(5),
      width: theme.spacing(5),
      alignSelf: 'flex-start',
      [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(2),
      },
    },
  };
};
